module.exports = __webpack_public_path__ + "static/media/icon-character__margaret-thatcher-hover.89f1cb78.svg";